import { LicitacaoResumida } from "../licitacao-resumida";

export class RetornoImportarLicitacoes {
  mensagem: string;
  licitacoesNaoImportadas: LicitacaoResumida[];
  licitacoesImportadas: LicitacaoResumida[];
  listaPendencias: any[];
  erros: string[];
  tipoErro: number;
  nomeArquivo: string;

  constructor(obj?: any) {
    if (obj) {
      this.mensagem = obj.mensagem;
      this.erros = obj.erros;
      this.tipoErro = obj.tipoErro;
      this.licitacoesNaoImportadas = obj.licitacoesNaoImportadas?.map(
        (lni) => new LicitacaoResumida(lni)
      );
      this.licitacoesImportadas = obj.licitacoesImportadas?.map(
        (li) => new LicitacaoResumida(li)
      );
      this.listaPendencias = obj.listaPendencias;
    }
  }

  corSituacao(): string {
    return this.licitacoesNaoImportadas?.length > 0 ||
      !this.licitacoesImportadas
      ? "danger"
      : "success";
  }
  houveImportacao(): boolean {
    return this.licitacoesImportadas?.length > 0;
  }
  houveNaoImportacao(): boolean {
    return this.licitacoesNaoImportadas?.length > 0;
  }
  houvePendencias(): boolean {
    return this.listaPendencias?.length > 0;
  }
}
